import { AIFunction } from '@/utils/const';
import { t } from '@/utils/helper/intl';

import { getBasePromptConfig } from './common';
import { ModelIdEnum } from './constants';

export const imageToVideoModelConfig = [
  {
    modelName: 'Kling v2.6 Pro',
    modelValue: ModelIdEnum.IMAGE_TO_VIDEO_Kling_v2_6_Pro,
    iconUrl: '/images/kling2.6pro.png',
    formConfig: [
      getBasePromptConfig(AIFunction.Image2Video),
      {
        type: 'file',
        label: 'merror.0.5.image',
        key: 'image',
        required: true,
        config: {
          type: 'image',
          accept: '.jpg,.jpeg,.png',
          tips: 'fc.be23b0f2',
          maxCount: 1,
          allowLibrarySelect: true,
          multiple: false,
          feature: AIFunction.Image2Video,
          rules: [
            {
              maxSize: 10 * 1024 * 1024,
              minResolution: '300*300',
              maxResolution: '5000*5000',
            },
          ],
        },
      },
      {
        type: 'radio',
        value: 5,
        label: 'merror.assets.duration',
        key: 'duration',
        credit: true,
        config: {
          options: [
            { label: '5s', value: 5 },
            { label: '10s', value: 10 },
          ],
        },
      },
      {
        type: 'switch',
        label: '359830b6b443f2a3fae314a287685809',
        key: 'sound',
        value: true,
        credit: true,
      },
    ],
  },
  {
    modelName: 'Seedance v1.5 Pro',
    modelValue: ModelIdEnum.IMAGE_TO_VIDEO_Seedance_v1_5_Pro,
    iconUrl: '/images/seedance1.5pro.png',
    formConfig: [
      getBasePromptConfig(AIFunction.Image2Video),
      {
        type: 'file',
        label: 'merror.0.5.image',
        key: 'image',
        required: true,
        config: {
          type: 'image',
          accept: '.jpg,.png,.jpeg,.webp',
          tips: 'JPG-PNG-10MB-300',
          maxCount: 1,
          allowLibrarySelect: true,
          multiple: false,
          feature: AIFunction.Image2Video,
          rules: [
            {
              maxSize: 10 * 1024 * 1024,
              minResolution: '300*300',
              maxResolution: '5000*5000',
            },
          ],
        },
      },
      {
        type: 'file',
        label: 'fc.b13049e7',
        key: 'last_image',
        config: {
          type: 'image',
          accept: '.jpg,.png,.jpeg,.webp',
          tips: 'JPG-PNG-10MB-300',
          maxCount: 1,
          allowLibrarySelect: true,
          multiple: false,
          feature: AIFunction.Image2Video,
          rules: [
            {
              maxSize: 10 * 1024 * 1024,
              minResolution: '300*300',
              maxResolution: '5000*5000',
            },
          ],
        },
      },
      {
        type: 'AspectRatio',
        value: undefined,
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: 'auto', value: undefined },
            { label: '21:9', value: '21:9' },
            { label: '16:9', value: '16:9' },
            { label: '4:3', value: '4:3' },
            { label: '1:1', value: '1:1' },
            { label: '3:4', value: '3:4' },
            { label: '9:16', value: '9:16' },
          ],
        },
      },
      {
        type: 'durationSlider',
        value: 5,
        label: 'merror.assets.duration',
        key: 'duration',
        credit: true,
        config: {
          min: 4,
          max: 12,
          step: 1,
          unit: 's',
        },
      },
      {
        type: 'radio',
        value: '720p',
        label: 'merror.export.resolution',
        key: 'resolution',
        credit: true,
        config: {
          options: [
            { label: '720p', value: '720p' },
            { label: '480p', value: '480p' },
          ],
        },
      },
      {
        type: 'checkbox',
        label: 'merror.0.8.lipsync.generatorAudio',
        key: 'generate_audio',
        value: true,
        credit: true,
        advanced: true,
        config: {
          label: t('fc.33302773'),
        },
      },
      {
        type: 'checkbox',
        label: 'fc.8d436b83',
        key: 'camera_fixed',
        value: false,
        advanced: true,
        config: {
          label: t('fc.b16ac978'),
        },
      },
    ],
  },
  {
    modelName: 'Sora 2 Pro',
    modelValue: ModelIdEnum.IMAGE_TO_VIDEO_Sora_2_Pro,
    iconUrl: '/images/sora2.png',
    formConfig: [
      getBasePromptConfig(AIFunction.Image2Video),
      {
        type: 'file',
        label: 'merror.0.5.image',
        key: 'image',
        required: true,
        config: {
          type: 'image',
          accept: '.jpg,.png,.jpeg,.webp',
          tips: 'JPG-PNG-10MB-300',
          maxCount: 1,
          allowLibrarySelect: true,
          multiple: false,
          feature: AIFunction.Image2Video,
          rules: [
            {
              maxSize: 10 * 1024 * 1024,
              minResolution: '300*300',
              maxResolution: '5000*5000',
            },
          ],
        },
      },
      {
        type: 'radio',
        value: 4,
        label: 'merror.assets.duration',
        key: 'duration',
        credit: true,
        config: {
          options: [
            { label: '4s', value: 4 },
            { label: '8s', value: 8 },
            { label: '12s', value: 12 },
          ],
        },
      },
      {
        type: 'radio',
        value: '720p',
        label: 'merror.export.resolution',
        key: 'resolution',
        credit: true,
        config: {
          options: [
            { label: '720p', value: '720p' },
            { label: '1080p', value: '1080p' },
          ],
        },
      },
    ],
  },
  {
    modelName: 'Veo 3.1',
    modelValue: ModelIdEnum.IMAGE_TO_VIDEO_Veo_3_1,
    iconUrl: '/images/veo3.png',
    formConfig: [
      getBasePromptConfig(AIFunction.Image2Video),
      {
        type: 'file',
        label: 'merror.0.5.image',
        key: 'image',
        required: true,
        config: {
          type: 'image',
          accept: '.jpg,.png,.jpeg,.webp',
          tips: 'JPG-PNG-10MB-300',
          maxCount: 1,
          multiple: false,
          allowLibrarySelect: true,
          feature: AIFunction.Image2Video,
          rules: [
            {
              maxSize: 10 * 1024 * 1024,
              minResolution: '300*300',
              maxResolution: '5000*5000',
            },
          ],
        },
      },
      {
        type: 'AspectRatio',
        value: '9:16',
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: '9:16', value: '9:16' },
            { label: '16:9', value: '16:9' },
          ],
        },
      },
      {
        type: 'radio',
        value: '720p',
        label: 'merror.export.resolution',
        key: 'resolution',
        config: {
          options: [
            { label: '720p', value: '720p' },
            { label: '1080p', value: '1080p' },
          ],
        },
      },
      {
        type: 'radio',
        value: 4,
        label: 'merror.assets.duration',
        key: 'duration',
        credit: true,
        config: {
          options: [
            { label: '4s', value: 4 },
            { label: '6s', value: 6 },
            { label: '8s', value: 8 },
          ],
        },
      },
      {
        type: 'switch',
        label: '359830b6b443f2a3fae314a287685809',
        key: 'generate_audio',
        value: false,
        credit: true,
      },
    ],
  },
  {
    modelName: 'Kling 2.5 Turbo Pro',
    modelValue: ModelIdEnum.IMAGE_TO_VIDEO_Kling_2_5_Turbo_Pro,
    iconUrl: '/images/kling.png',
    formConfig: [
      getBasePromptConfig(AIFunction.Image2Video),
      {
        type: 'file',
        label: 'merror.0.5.image',
        key: 'image',
        required: true,
        config: {
          type: 'image',
          accept: '.jpg,.png,.jpeg',
          tips: 'JPG-PNG-10MB-300',
          maxCount: 1,
          multiple: false,
          allowLibrarySelect: true,
          feature: AIFunction.Image2Video,
          rules: [
            {
              maxSize: 10 * 1024 * 1024,
              minResolution: '300*300',
              maxResolution: '5000*5000',
            },
          ],
        },
      },
      {
        type: 'radio',
        value: 5,
        label: 'merror.assets.duration',
        key: 'duration',
        credit: true,
        config: {
          options: [
            { label: '5s', value: 5 },
            { label: '10s', value: 10 },
          ],
        },
      },
    ],
  },
];
